<template>
  <div id="details">
    <div id="closeBg" v-on:click="closeDetails(true)"></div>
    <div id="detailsContent">
      <div id="finderClose"><svg id="modal-close" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M 0,0 L 20,20 M 0,20 L 20,0" stroke-width=4/></path>
      </svg></div>
      <detailType1 :DemandID="DemandID" v-on:closeDetails="closeDetails"></detailType1>
    </div>
  </div>
</template>

<script>
export default {
  name: "detailsWindow",
  components: {
    detailType1: () => import('@/components/detailTypes/detailType1'),
  },
  props: {
    DemandID: {
      type: Number,
      default: 0
    }
  },
  methods: {
    closeDetails(unblockDemand) {
      console.log('закрыть окно')
      console.log(unblockDemand);
      if (unblockDemand) {
        this.$myApi.callSharpApi({
          externalType: 'ms',
          msUrl: 'back-loannp/CallCenter/removeBlockSimpleDemand',
          urlType: '',
          method: 'GET',
          UserID: localStorage.getItem('UserID'),
          DemandID: this.DemandID,
        }).then(() => {
        }).catch(res => {
          alert(res)
        })
      }
      this.$emit('closeDetails');
    }
  }
}
</script>

<style scoped>
#details { position: fixed; top:0; left:0; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; z-index: 9999; }
#closeBg{ position: absolute; top:0; left:0; width: 100%; height: 100%; background:rgba(5, 51, 37, 0.66); cursor: pointer }
#detailsContent { background: white; min-width: calc(600px - 40px); min-height: calc(900px - 40px); width: 90%; position: relative; padding: 20px 20px }
#finderClose{position: absolute;top:-40px;right: -15px; width: 30px;height: 30px;pointer-events: none}
svg{ width: 100%; height: 100%; stroke: white }
</style>
